import { render, staticRenderFns } from "./ysxt_detail.vue?vue&type=template&id=8801c5ea&"
import script from "./ysxt_detail.vue?vue&type=script&lang=js&"
export * from "./ysxt_detail.vue?vue&type=script&lang=js&"
import style0 from "./ysxt_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports